'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchBookInfoFailed = exports.isSubmittingMeeting = exports.shouldRenderBookingPage = exports.bookingPageLoading = exports.getIsFetchingPublicGlobalBranding = exports.getIsFetchingCompanyName = exports.getIsFetchingPublicAvailability = exports.userProfileLoadSuccess = exports.availabilityFetchSuccess = exports.availabilityFetchFailed = exports.meetingCreationFailed = exports.meetingCreationSuccess = exports.getCompanyNameFetchStatus = exports.getPublicGlobalBrandingFetchStatus = exports.getUserProfileFetchStatus = exports.getPublicAvailabilityInfoFetchStatus = exports.getMeetingsCreateStatus = undefined;
exports.getRequestStatus = getRequestStatus;

var _reselect = require('reselect');

var _get = require('transmute/get');

var _get2 = _interopRequireDefault(_get);

var _RequestStatusTypes = require('MeetingsBase/constants/RequestStatusTypes');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getRequestStatuses = function getRequestStatuses(state) {
  return state.requestStatus;
};

function getRequestStatus(requestType) {
  return (0, _reselect.createSelector)([getRequestStatuses], function (requestStatuses) {
    return requestStatuses.get(requestType) || _RequestStatusTypes.UNINITIALIZED;
  });
}
var getBookInfo = (0, _get2.default)('bookInfo');

var getMeetingsCreateStatus = exports.getMeetingsCreateStatus = getRequestStatus('MEETING_CREATE');
var getPublicAvailabilityInfoFetchStatus = exports.getPublicAvailabilityInfoFetchStatus = getRequestStatus('PUBLIC_AVAILABILITY_INFO_FETCH');
var getUserProfileFetchStatus = exports.getUserProfileFetchStatus = getRequestStatus('USER_PROFILE_FETCH');
var getPublicGlobalBrandingFetchStatus = exports.getPublicGlobalBrandingFetchStatus = getRequestStatus('PUBLIC_GLOBAL_BRANDING_FETCH');

var getCompanyNameFetchStatus = exports.getCompanyNameFetchStatus = getRequestStatus('COMPANY_NAME_FETCH');

var meetingCreationSuccess = exports.meetingCreationSuccess = (0, _reselect.createSelector)([getMeetingsCreateStatus], function (meetingsCreateStatus) {
  return meetingsCreateStatus === _RequestStatusTypes.SUCCEEDED;
});
var meetingCreationFailed = exports.meetingCreationFailed = (0, _reselect.createSelector)([getMeetingsCreateStatus], function (meetingsCreateStatus) {
  return meetingsCreateStatus === _RequestStatusTypes.FAILED;
});
var availabilityFetchFailed = exports.availabilityFetchFailed = (0, _reselect.createSelector)([getPublicAvailabilityInfoFetchStatus], function (publicAvailabilityInfoFetchStatus) {
  return publicAvailabilityInfoFetchStatus === _RequestStatusTypes.FAILED;
});
var availabilityFetchSuccess = exports.availabilityFetchSuccess = (0, _reselect.createSelector)([getPublicAvailabilityInfoFetchStatus], function (publicAvailabilityInfoFetchStatus) {
  return publicAvailabilityInfoFetchStatus === _RequestStatusTypes.SUCCEEDED;
});
var userProfileLoadSuccess = exports.userProfileLoadSuccess = (0, _reselect.createSelector)([getUserProfileFetchStatus], function (userProfileFetchStatus) {
  return userProfileFetchStatus === _RequestStatusTypes.SUCCEEDED;
});

var getIsFetchingPublicAvailability = exports.getIsFetchingPublicAvailability = (0, _reselect.createSelector)([getPublicAvailabilityInfoFetchStatus], function (publicAvailabilityInfoFetchStatus) {
  return publicAvailabilityInfoFetchStatus === _RequestStatusTypes.UNINITIALIZED || publicAvailabilityInfoFetchStatus === _RequestStatusTypes.STARTED;
});

var getIsFetchingCompanyName = exports.getIsFetchingCompanyName = (0, _reselect.createSelector)([getCompanyNameFetchStatus], function (companyNameFetchStatus) {
  return companyNameFetchStatus === _RequestStatusTypes.UNINITIALIZED || companyNameFetchStatus === _RequestStatusTypes.STARTED;
});

var getIsFetchingPublicGlobalBranding = exports.getIsFetchingPublicGlobalBranding = (0, _reselect.createSelector)([getUserProfileFetchStatus, getPublicGlobalBrandingFetchStatus], function (userProfileFetchStatus, publicGlobalBrandingFetchStatus) {
  return userProfileFetchStatus === _RequestStatusTypes.SUCCEEDED && (publicGlobalBrandingFetchStatus === _RequestStatusTypes.UNINITIALIZED || publicGlobalBrandingFetchStatus === _RequestStatusTypes.STARTED);
});

var bookingPageLoading = exports.bookingPageLoading = (0, _reselect.createSelector)([getUserProfileFetchStatus, getIsFetchingPublicAvailability], function (userProfileFetchStatus, isFetchingPublicAvailability) {
  return isFetchingPublicAvailability || userProfileFetchStatus === _RequestStatusTypes.UNINITIALIZED || userProfileFetchStatus === _RequestStatusTypes.STARTED;
});

var shouldRenderBookingPage = exports.shouldRenderBookingPage = (0, _reselect.createSelector)([bookingPageLoading, getMeetingsCreateStatus], function (isBookingPageLoading, meetingsCreateStatus) {
  var meetingNotCreatedYet = meetingsCreateStatus === _RequestStatusTypes.UNINITIALIZED || meetingsCreateStatus === _RequestStatusTypes.STARTED;
  return !isBookingPageLoading && meetingNotCreatedYet;
});

var isSubmittingMeeting = exports.isSubmittingMeeting = (0, _reselect.createSelector)([getMeetingsCreateStatus], function (meetingsCreateStatus) {
  return meetingsCreateStatus === _RequestStatusTypes.STARTED;
});

var fetchBookInfoFailed = exports.fetchBookInfoFailed = (0, _reselect.createSelector)([getPublicAvailabilityInfoFetchStatus, getBookInfo], function (publicAvailabilityInfoFetchStatus, _ref) {
  var availableTimePeriods = _ref.availableTimePeriods;
  return publicAvailabilityInfoFetchStatus === _RequestStatusTypes.FAILED || !Boolean(availableTimePeriods);
});


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/workspace/MeetingsUI/MeetingsLib/target/src/MeetingsLib/static-2.875/js/selectors/RequestStatusSelectors.js
// module id = 43
// module chunks = 0